import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import { addAdmin, deleteAdmin, editAdmin } from "../../../api/admins";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { getRolesDropdown } from "../../../api/roles";
import SearchSelectBox from "../../../components/SearchSelectBox";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";

const AddAdmin = () => {
  const { t } = useTranslation();
  const { addAdminSchema } = useCustomValidation();
  const navigate = useNavigate();

  const { setData, loading, error, success } = useResponse(addAdmin, () => {
    navigate("/admins");
  });

  const [passwordSee, setPasswordSee] = useState(false);
  const [confirmPasswordSee, setConfirmPasswordSee] = useState(false);
  const [rolesOptions, setRolesOptions] = useState([]);

  useEffect(() => {
    getRolesDropdown().then((res) => {
      const formatted = res?.data?.map((role) => ({
        label: role.name,
        value: role._id,
      }));
      setRolesOptions(formatted);
      if (formatted.length) {
        validation.setFieldValue("roleId", formatted[0]);
      }
    });
  }, []);


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      roleId: null,
      isActive: true,
    },
    validationSchema: addAdminSchema,
    onSubmit: (values) => {
      const data = {
        name: values.name,
        email: values.email,
        password: values.password,
        roleId: values.roleId?.value,
      };
      setData({ data, type: "add" });
    },
  });

  const generatePassword = () => {
    const length = 25;
    const chars =
      "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let password = "";
    const array = new Uint32Array(length);
    window.crypto.getRandomValues(array);
    for (let i = 0; i < length; i++) {
      password += chars[array[i] % chars.length];
    }
    validation.setFieldValue("password", password);
    validation.setFieldValue("confirmPassword", password);
    validation.setFieldTouched("confirmPassword", false);
  };
  // console.log(validation, "--------------------")


  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={t("btns.Add") + " " + t("Admin")} />

        <Form
          className="needs-validation"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Name")}</Label>
                <Input
                  name="name"
                  placeholder={t("Name")}
                  type="text"
                  onChange={validation.handleChange}
                  // onBlur={validation.handleBlur}
                  value={validation.values.name}
                  invalid={!!(validation.touched.name && validation.errors.name)}
                />
                <FormFeedback>
                  {validation.errors.name}
                </FormFeedback>
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Email")}</Label>
                <Input
                  name="email"
                  placeholder={t("Email")}
                  type="email"
                  onChange={validation.handleChange}
                  // onBlur={validation.handleBlur}
                  value={validation.values.email}
                  invalid={!!(validation.touched.email && validation.errors.email)}
                />
                <FormFeedback>
                  {validation.errors.email}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Role")}</Label>
                <SearchSelectBox
                  api={getRolesDropdown}
                  name="roleId"
                  placeholder={t("Select Role")}
                  value={validation.values.roleId}
                  label="name"
                  setValue={(value) => {
                    console.log("111111111111111111", validation);

                    validation.setFieldValue("roleId", value)
                  }}
                  // handleBlur={() => validation.setFieldTouched("roleId", true)}
                  error={!!(validation.touched.roleId && validation.errors.roleId)}
                />
                {validation.touched.roleId && validation.errors.roleId && (
                  <div className="text-danger mt-1">{validation.errors.roleId}</div>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Password")}</Label>
                <InputGroup>
                  <InputGroupText
                    onClick={() => setPasswordSee(!passwordSee)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className={`fas fa-eye${passwordSee ? "" : "-slash"}`}></i>
                  </InputGroupText>
                  <Input
                    name="password"
                    placeholder={t("Password")}
                    type={passwordSee ? "text" : "password"}
                    onChange={validation.handleChange}
                    // onBlur={validation.handleBlur}
                    value={validation.values.password}
                    invalid={!!(validation.touched.password && validation.errors.password)}
                  />
                  <FormFeedback>
                    {validation.errors.password}
                  </FormFeedback>
                </InputGroup>
                <button type="button" className="btn btn-sm btn-link mt-2" onClick={generatePassword}>
                  {t("Generate Password")}
                </button>
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Confirm Password")}</Label>
                <InputGroup>
                  <InputGroupText
                    onClick={() => setConfirmPasswordSee(!confirmPasswordSee)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className={`fas fa-eye${confirmPasswordSee ? "" : "-slash"}`}></i>
                  </InputGroupText>
                  <Input
                    name="confirmPassword"
                    placeholder={t("Confirm Password")}
                    type={confirmPasswordSee ? "text" : "password"}
                    onChange={validation.handleChange}
                    // onBlur={validation.handleBlur}
                    value={validation.values.confirmPassword}
                    invalid={
                      !!(validation.touched.confirmPassword && validation.errors.confirmPassword)
                    }
                  />
                  <FormFeedback>
                    {validation.errors.confirmPassword}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>

          <FormButtonHandler btnTxt={t("Add")} loading={loading} />

          <ResultHandler
            error={error}
            success={success}
            successMsg={t("Created Successfully!")}
          />
        </Form>
      </Container>
    </div>
  );
};

export default AddAdmin;
